
<template>
      <vs-dialog prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
            Vincular docente
          </h4>
        </template>

        <div class="con-form">
            <vs-row>
                <vs-col w="12">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución de procedencia
                        </label>
                        <vs-select v-if="boton == 'nuevo'" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                        <div v-else v-for="option in instituciones" :key="option.id">
                            <h6 class="pl-2" v-if="option.id == institucion">{{option.text}}</h6>
                        </div>
                    </form>
                </vs-col>
                <vs-col w="12">
                    <form autocomplete="off">
                        <label for="docente" class="labelInput">
                            Docente
                        </label>
                        <vs-select v-if="boton == 'nuevo'" :loading="loadingDocente" filter class="aqui pt-0" id="docente" placeholder="Seleccionar Institución" :key="docenteId" v-model="docente" :disabled="!docentes.length">
                            <template #message-danger v-if="errorFields.includes('docente')">
                                Requerido
                            </template>
                            <vs-option v-for="option in docentes" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                        <div v-else>
                            <h6 class="pl-2" v-if="!docentes.length">Espere un momento</h6>
                            <div v-else v-for="option in docentes" :key="option.id">
                                <h6 class="pl-2" v-if="option.id == docente">{{option.text}}</h6>
                            </div>
                        </div>
                    </form>
                </vs-col>
                <vs-col w="12">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución a vincular
                        </label>
                        <vs-select class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucionD" :disabled="!instituciones.length">
                            <template #message-danger v-if="errorFields.includes('institucionD')">
                                Requerido
                            </template>
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
            </vs-row>
        </div>

        <template #footer>
          <div class="footer-dialog">
            <vs-row>
                <vs-col sm="6" lg="6">
                <vs-button
                    danger
                    flat
                    @click="active = false"
                >
                    Cancelar
                </vs-button>
                </vs-col>
                <vs-col sm="6" lg="6">
                <vs-button
                    success
                    @click="postVincularDocente()"
                    class="ml-auto"
                >
                    Aceptar
                </vs-button>
                </vs-col>
            </vs-row>
          </div>
        </template>
      </vs-dialog>
</template>
<script>
import academico from '../../../../../api/requests/academico.js'
export default {
    props:[
        'value',
        'infoRow',
        'instituciones',
        'boton'
    ],
    data:() => ({
        active: false,
        institucion: '',
        institucionD: '',
        institucionId: (new Date()).getTime(),
        docente: '',
        docentes: [],
        loadingDocente: false,
        docenteId: (new Date()).getTime(),
        errorFields: []
    }),
    methods:{
        getInfo(){
            this.institucion = this.infoRow.institucion_id
            this.docente = this.infoRow.persona_id
        },
        async getDocentesVincular(){
            try {
                this.loadingDocente = true
                const {data: response} = await academico.getDocentesVincular(this.institucion)
                this.docentes = response
                this.docenteId = (new Date()).getTime()
                this.loadingDocente = false
            }
            catch{
                this.loadingDocente = false
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('number', parseInt(this.institucion))) {
                this.errorFields.push('institucion')
            }
            if (!this.checkByType ('number', parseInt(this.institucionD))) {
                this.errorFields.push('institucionD')
            }
            if (!this.checkByType ('number', parseInt(this.docente))) {
                this.errorFields.push('docente')
            }
            if (!this.errorFields.length){
                return {
                    institucion_id: this.institucionD,
                    persona_id: this.docente,
                    status_id: 1
                }
            } else {
                return null
            }
        },
        async postVincularDocente(){
            const loading = this.$vs.loading()
            try {
                const info = this.sanityForm()
                const payload = Object.assign(info)
                const {data: response} = await academico.postVincularDocente(payload)
                loading.close()
                this.active = false
                this.institucionD = ''
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: 'Se ha vinculado éxitosamente'
                })
            }
            catch(error){
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Hubo un problema',
                    text: 'Favor de contactar al administrador.'
                })
            }
        },
    },
    watch:{
        value (val) {
            this.active = val
        },      
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        institucion(){
            this.getDocentesVincular()
        },
        infoRow(){
            this.getInfo()
        }
    }
}
</script>
